<template>
    <div class="courseList_dialog_wrap" v-if="dialogVisibe">
        <el-dialog
        title="关联课程"
        :visible.sync="dialogVisibe"
        width="800px"
        custom-class="courseList_dialog"
        @close="cancelData">
        <div class="courselist_market_table">
			<!-- <div class="courselist_market_tips">提示：该列表只显示已上架且有章节的课程</div> -->
            <div class="courselist_table_search">
                <div class="courselist_table_search_con">
                   <span>选择平台：</span>
                   <el-select v-model="searchObj.come_from" placeholder="请选择" @change="search()">
                     <el-option
                       v-for="item in platFormList"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value"
                     >
                     </el-option>
                   </el-select>
                </div>
                <div class="courselist_table_search_con">
                    <el-input placeholder="请输入课程标题查询" v-model="searchObj.product_name" class="courselist_input_tit">
                        <el-button slot="append" type="primary" @click="search">查询</el-button>
                    </el-input>
                </div>
            </div>
           <el-scrollbar class="maket_scrollbar">
                <el-table :data="tableListObj.data" @row-click="rowClick" :header-cell-style="{background: '#F5F7FA',color:'#454D53'}">
                    <el-table-column width="55">
                        <template slot-scope="scope">
                            <el-checkbox :value="selectIds.includes(scope.row.id)" :disabled="disableIds.includes(scope.row.id) || scope.row.is_select==2"  @click.native.stop.prevent="rowClick(scope.row)"></el-checkbox>
                        </template>
                    </el-table-column>
                    <el-table-column property="img" label="封面" width="200">
                        <template slot-scope="scope">
                            <img :src="scope.row.img" alt="" style="width:67px;height:50px"/>
                        </template>
                    </el-table-column>
                    <el-table-column property="title" label="标题" width="260"></el-table-column>
                    <el-table-column property="price_fomat" label="价格"></el-table-column>
                </el-table>
                <Pagination @change="changeSize" :total="tableListObj.total"  v-model="searchObj.page" v-if="Math.ceil(tableListObj.total / searchObj.limit) > 1"></Pagination>
           </el-scrollbar>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="cancelData">取 消</el-button>
            <el-button type="primary" @click="sure">确 定</el-button>
        </span>
        </el-dialog>
    </div>
</template>
<script>
import { mapActions } from 'vuex'
import Pagination from '@/components/pagination/pagination.vue'
const allPlatFormsList = [
    {label: '抖音', value: 1},
    {label: '快手', value: 2},
    {label: '微信', value: 3},
    {label: '视频号', value: 4},
    {label: '小红书', value: 5},
    {label: '抖店', value: 6},
]
const platFormListTypeObj = {
    1: [1,2,3],
    2: [1,6,2,3,4,5]
}
export default {
    props: {
       value: {
           type: Boolean,
           default: false
       },
	   smsType: {
        type: [Number, String],
	       default: 1
	   },
		smsObjId: {
			type: [Number, String],
			default: 0
		},
        platFormListType: { // 平台选择类型
            type: [Number, String],
            default: 1
        },
        activeQrcodeMode: { // 当前转私短信tab激活模式
            type: [Number, String],
            default: ''
        },
        selectedCourses: { // 已选课程列表
            type: Array,
            default: () => []
        }
    },
    components: {
        Pagination
    },
    data() {
        return {
            dialogVisible: false,
            checked: false,
            indeterminate: false,
            tableListObj: {
                data: [],
                total: 0
            },
            searchObj: {
				come_from: 1,
                product_name:'',
                page: 1,
                limit: 10
            },
            headerList: [
                {
                    prop: 'img',
                    label: '封面',
                    width: 200
                },
                {
                    prop: 'title',
                    label: '标题'
                }
            ],
			selectIds: [],
			selectCourses: [],
			disableIds: [],
        }
    },
    async created() {
       // 初始化逻辑已移到watch中
    },
    methods: {
		...mapActions('message', ['authorcourse','smsproductnopage']),
        // 改变默认选择平台
        changeDefaultPlatform(){
            let platFormObj = {
                '/': 1, // 抖音
                '/ks/': 2, // 快手
                '/wx/': 3, // 微信
                '/sph/': 4, // 微信视频号
                '/xhs/': 5, // 小红书
                '/dd/': 6 // 抖店
            }
            let defaultComeFrom = platFormListTypeObj[this.platFormListType].includes(platFormObj[this.staticPath]) ? platFormObj[this.staticPath] : 1
            this.searchObj.come_from = defaultComeFrom
        },
        rowClick(row) {
            if(row.is_select == 2 || this.disableIds.includes(row.id)) {
                return
            }
            if(this.selectIds.includes(row.id)) {
                let index = this.selectIds.findIndex(item => item == row.id)
                this.selectIds.splice(index, 1)
                let courseIndex = this.selectCourses.findIndex(item => item.id == row.id)
                if(courseIndex > -1) {
                    this.selectCourses.splice(courseIndex, 1)
                }
            } else {
                this.selectIds.push(row.id)
                this.selectCourses.push(row)
            }
            this.selectIds = [...this.selectIds]
            this.selectCourses = [...this.selectCourses]
        },
        sure() {
            this.$emit('input', false)
            this.$emit('selectList', this.selectCourses)
        },
        changeSize(size) {
            this.searchObj.page = size
            this.getCourseListFun()
        },
        async getCourseListFun(flag) {
            if(flag) {
                this.searchObj.page = 1
            }
			const searchObj = Object.assign({sms_obj_id: this.smsObjId,sms_type: this.smsType}, this.searchObj)
            if(this.activeQrcodeMode == 2) {
                searchObj.private_type = 2
            }
            let res = await this.authorcourse(searchObj)
			const {data = [],count = 0} = res
			if(this.smsType == 3){
				// 只判断为 3 的
				// is_select 1-可用 2-禁用
				this.disableIds = data.map((item) => {
					if(item.is_select == 2){
						return item.id
					}
				})
			}
            this.tableListObj = {
                data: data,
                total: count
            }
        },
        async search() {
			this.selectIds = []
			await this.getProductIds()
            await this.getCourseListFun(true)
        },
        cancelData() {
            this.selectIds = []
            this.$emit('input', false)
        },
		async getProductIds() {
            let wework_mod = this.activeQrcodeMode == 2? 0 : this.activeQrcodeMode
			let searchObj = Object.assign({sms_obj_id: this.smsObjId,sms_type: this.smsType},{come_from: this.searchObj.come_from, wework_mod: wework_mod})
            if(this.activeQrcodeMode == 2) {
                searchObj.private_type = 2
            }
		    let res = await this.smsproductnopage(searchObj)
			const {data = []} = res
			if(data.length) {
				this.selectIds = data.map((item) => item.product_id)
			}
		}
    },
	computed: {
		dialogVisibe: {
			get() {
				return this.value
			},
			set(news) {
				this.$emit('input',news);
			}
		},
        platFormList(){
            return platFormListTypeObj[this.platFormListType].map(item=>{
                return allPlatFormsList.find(item2=>item2.value==item)
            })
        }
	},
    watch: {
        async dialogVisibe(news) {
            if(news) {
                this.changeDefaultPlatform()
				await this.getProductIds()
                await this.getCourseListFun(true)
                
                // 初始化已选课程
                this.selectIds = this.selectedCourses.map(item => item.id)
                this.selectCourses = [...this.selectedCourses]
                console.log(" this.selectCourses ",this.selectCourses)
            }
        }
    }
}
</script>
<style lang="less">
    .courseList_dialog {
        .el-dialog__body {
            padding: 12px 20px;
        }
    }
	.courselist_market_tips{
		margin-bottom:15px;
        color: red;
	}
    .courselist_market_table {
        height: 600px;
        display: flex;
        flex-direction: column;
        .maket_scrollbar {
            flex: 1 0 auto;
            height: 0;
        }
        .pagination_wrap {
            padding: 12px 0 0 0;
        }
        .courselist_table_search {
            margin-bottom: 12px;
            display: flex;
            flex-wrap: wrap;
            flex-shrink: 0;
            .courselist_table_search_con {
                flex-shrink: 0;
                margin-right: 20px;
            }
            .courselist_input_tit {
                .el-input-group__append, .el-input-group__prepend {
                    background-color: #409eff;
                    border-color: #409eff;
                    color: #fff;
                }
            }
        }
    }
</style>